/** Shared “current / audit preview” squircle checkbox + pale halo — Section, Step, Substep. */

/** Section-focused `/audit-trail/preview-current-node`: dim step/substep/leaf checkboxes when the section has steps. */
export const AUDIT_PREVIEW_SECTION_DESCENDANT_OPACITY = 0.5;

/** Merge onto the checkbox outer wrapper (with position/display) — not used on the section row itself. */
export const auditPreviewSectionDescendantWrapStyle = (checkboxState) =>
  checkboxState?.auditPreviewDimDescendantCheckboxes === true
    ? { opacity: AUDIT_PREVIEW_SECTION_DESCENDANT_OPACITY }
    : {};

export const NODE_SELECTION_BLUE = "#0D6EFD";
export const HALO_OUTLINE_COLOR = "#97c1fd";
export const SELECTION_HALO_BG = "rgba(13, 110, 253, 0.18)";
export const HALO_PADDING = 2;
export const HALO_OUTER_RADIUS = 6;
export const HALO_INNER_SIZE = 20;
export const HALO_INNER_RADIUS = 6;

export const SELECTION_CHECKMARK_SVG = `url("data:image/svg+xml,${encodeURIComponent(
  "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 14'><path d='M3.5 7.5l2.5 2.5 4.5-5.5' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg>",
)}")`;

export const getHaloWrapperStyle = () => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  padding: HALO_PADDING,
  borderRadius: HALO_OUTER_RADIUS,
  backgroundColor: SELECTION_HALO_BG,
  flexShrink: 0,
});

/**
 * @param {{ disabled: boolean, isSource: boolean }} opts
 */
export const getHaloCheckboxStyle = ({ disabled, isSource }) => ({
  cursor: disabled ? "not-allowed" : isSource ? "not-allowed" : "pointer",
  appearance: "none",
  WebkitAppearance: "none",
  MozAppearance: "none",
  width: HALO_INNER_SIZE,
  height: HALO_INNER_SIZE,
  minWidth: HALO_INNER_SIZE,
  minHeight: HALO_INNER_SIZE,
  flexShrink: 0,
  boxSizing: "border-box",
  borderRadius: HALO_INNER_RADIUS,
  border: `1px solid ${HALO_OUTLINE_COLOR}`,
  backgroundColor: NODE_SELECTION_BLUE,
  backgroundImage: SELECTION_CHECKMARK_SVG,
  backgroundSize: "13px 13px",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  opacity: disabled ? 0.6 : 1,
});

/** Audit preview-current-node focused leaf: full-opacity halo (avoid disabled dim + native grey checkbox). */
export const getAuditPreviewReadonlyHaloCheckboxStyle = () => ({
  ...getHaloCheckboxStyle({ disabled: false, isSource: false }),
  cursor: "default",
  pointerEvents: "none",
  opacity: 1,
});

/** Light blue locked tile — only when `auditDescendantPreviewLocked` (audit preview-current-node). View-section/step use `allChildren*` without this flag. */
export const DESCENDANT_LOCKED_FILL = "#97c1fd";
/** Tighter corners + softer presence than focus halo checkboxes */
export const DESCENDANT_LOCKED_RADIUS = 3;
export const DESCENDANT_LOCKED_OPACITY = 0.5;

export const isDescendantLockedPreview = (
  checkboxState,
  isCurrent,
  isChecked,
  isSourceNode = false,
) =>
  checkboxState?.auditDescendantPreviewLocked === true &&
  !isSourceNode &&
  checkboxState?.allChildrenDisabled === true &&
  checkboxState?.allChildrenChecked === true &&
  !isCurrent &&
  !!isChecked;

/** Focused leaf on `/audit-trail/preview-current-node` — same light-blue tile as descendants (not browser accent). */
export const isAuditPreviewFocusedLeafCheckbox = (
  checkboxState,
  isCurrent,
  isChecked,
  isSourceNode = false,
) =>
  checkboxState?.auditPreviewCurrentNode === true &&
  isCurrent &&
  !!isChecked &&
  !isSourceNode;

export const getDescendantLockedCheckboxStyle = () => ({
  appearance: "none",
  WebkitAppearance: "none",
  MozAppearance: "none",
  width: HALO_INNER_SIZE,
  height: HALO_INNER_SIZE,
  minWidth: HALO_INNER_SIZE,
  minHeight: HALO_INNER_SIZE,
  flexShrink: 0,
  boxSizing: "border-box",
  borderRadius: DESCENDANT_LOCKED_RADIUS,
  border: `1px solid ${DESCENDANT_LOCKED_FILL}`,
  backgroundColor: DESCENDANT_LOCKED_FILL,
  backgroundImage: SELECTION_CHECKMARK_SVG,
  backgroundSize: "13px 13px",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  cursor: "not-allowed",
  opacity: DESCENDANT_LOCKED_OPACITY,
  pointerEvents: "none",
});
